import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.Columns = [];
    item.IDAutoDetalhe = 0;
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;
};
export const dataGet5 = async () => {
    return data;
};
export const getItems5 = async () =>  {
    console.log("services5")
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
        if($("#tipo_auto :selected").val() == "6" || $("#tipo_auto :selected").val() == "15"){
            if(Detalhes.autoGridRotulos != undefined){
                for (let i = 0; i < Detalhes.autoGridRotulos.length ; i++) {
                    var tipo_rotulos = Detalhes.autoGridRotulos[i].tipoRotulo;
                    var numeroRegisto = Detalhes.autoGridRotulos[i].numeroRegisto;
                    var idRegistoProduto = Detalhes.autoGridRotulos[i].idRegistoProduto;
                    var correlativa = Detalhes.autoGridRotulos[i].correlativa;
                    var Descricao_rotulos = Detalhes.autoGridRotulos[i].descricaoRotulo;
                    var Quantidade_rotulos = Detalhes.autoGridRotulos[i].quantidadeRotulo;
                    var SelosSegurancas_rotulos = Detalhes.autoGridRotulos[i].selosSegurancaSelagemRotulos;
                    var Etiquetas_selagem_rotulos = Detalhes.autoGridRotulos[i].etiquetasSegurancaRotulos;
                    var Sinetes_rotulos = Detalhes.autoGridRotulos[i].sinetesRotulos;
                    var idRotulo = Detalhes.autoGridRotulos[i].idRotulo;
                    var linha = Detalhes.autoGridRotulos[i].linha;
                    var selosRotulos = []
                    var etiquetasRotulos =  []
                    if(correlativa != null){
                        var valor = correlativa.split("-")[1]
                    }else{
                        var valor = ""
                    }
                    
                        SelosSegurancas_rotulos.map((SelosSegurancas_rotulos) => (
                            selosRotulos.push(SelosSegurancas_rotulos.idSelo)
                        
                        ));
                    
                  
                        Etiquetas_selagem_rotulos.map((Etiquetas_selagem_rotulos) => (
                            etiquetasRotulos.push(Etiquetas_selagem_rotulos.idEtiqueta)
                        
                        ));
                    
                        data.push({ 
                            tipo_rotulos : {text: tipo_rotulos},
                            Registo_rotulos : {text: numeroRegisto, value: idRegistoProduto},
                            Correlativa_rotulos : {text: correlativa, value: valor, idRotulo: idRotulo},
                            Descricao_rotulos : Descricao_rotulos,
                            Quantidade_rotulos: Quantidade_rotulos,
                            SelosSegurancas_rotulos: selosRotulos,
                            Etiquetas_selagem_rotulos : etiquetasRotulos,
                            Sinetes_rotulos : Sinetes_rotulos,
                            ProductID: linha,
                            IDAutoDetalhe: Detalhes.autoGridRotulos[i].idAutoDetalhe,
                            Discontinued: false,
                            Columns: [],
                            inEdit: false
                        })
                        //// FIM selagem (grid1)
                }
            }
            
            return data;
        }
    }else{
         return data
    }
    
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
